import { service, handleResponse, handleError } from "./apiService";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

export default {
    album(url = baseUrl + '/album/') {
        return {
            fetchAll: async (artistId, pageNo, pageSize) => service.get(url + '?artistId='  + artistId + '&pageNo=' + pageNo + '&pageSize=' + pageSize),
            fetchById: async id => service.get(url + id),
            update: async (id, formData) => service.post(url + "update/" + id, formData),
            delete: async id => service.post(url + "delete/" + id),
            create: async formData => service.post(url, formData),
            togglePublish: async (id, isPublished) => service.post(url + "togglepublish/" + id + "/" + isPublished),
            toggleForSale: async (id, isForSale) => service.post(url + "toggleforsale/" + id + "/" + isForSale),
            fetchFieldsToFilter: async () => service.get(url + "getFieldsToFilter")
        }
    }
}